import React, {Component} from "react";
import {ExtensionAdminService} from "../../../service/operation/extensionAdmin/ExtensionAdminService";
import ConfirmExtensionAdmin from "./ConfirmExtensionView";
import {CommonService} from "../../../service/commons/CommonService";
import {Growl} from "primereact/growl";

export default class ConfirmExtensionContainer extends Component {
    constructor(props) {
        super(props);
        this.extensionAdminService = new ExtensionAdminService();
        this.commonService = new CommonService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.getLoanAndGuarantee = this.getLoanAndGuarantee.bind(this);
        this.rejectExtension = this.rejectExtension.bind(this);
        this.confirmExtension = this.confirmExtension.bind(this);

        this.state = {
            isLoading: true,
            isAdmin: this.props.location.state.isAdmin,
            returnPath: this.props.location.state.returnPath,
            loanId: this.props.location.state.loanId,
            loan: [],
            guarantee: [],
            extension: [],
        };

        this.getLoanAndGuarantee()
    }

    getLoanAndGuarantee() {
        return this.commonService.getLoanAndGuarantee(this.state.loanId).then(
            res => {
                this.setState({
                    isLoading: false,
                    loan: res[0],
                    guarantee: res[1],
                    extension: [res[2]],
                });
            }
        );
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true,
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    rejectExtension() {
        this.loading();
        this.extensionAdminService.rejectExtension(this.state.loan[0].idFolioPrest, this.state.loan[0].statusPV)
            .then(response => {
                if (response.error !== "") {
                    this.handleReturnButton({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.handleReturnButton({
                        severity: 'success',
                        sumary: 'Éxito',
                        detail: 'La prórroga se ha rechazado exitosamente',
                    });
                }
            });
    }

    confirmExtension() {
        this.loading();
        this.extensionAdminService.confirmExtension(this.state.loan[0].idFolioPrest, this.state.loan[0].statusPV)
            .then(response => {
                if (response.error !== "") {
                    this.handleReturnButton({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.handleReturnButton({
                        severity: 'success',
                        sumary: 'Éxito',
                        detail: 'La prórroga se ha confirmado exitosamente',
                    });
                }
            });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <ConfirmExtensionAdmin
            isLoading={this.state.isLoading}
            messagesGrowl={messagesGrowl}
            handleReturnButton={this.handleReturnButton}
            isAdmin={this.state.isAdmin}
            extension={this.state.extension}
            loan={this.state.loan}
            guarantee={this.state.guarantee}
            rejectExtension={this.rejectExtension}
            confirmExtension={this.confirmExtension}
        />
    }
};